import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import { formatNumber, grpupedOrderStatus, numberPrecision } from "../../../../helpers/UtilityHelper"
import InfoBox from "../../../../common/InfoBox"
import { StackedBarChart } from "../../../charts/BarChart"
import { STATUS_COLORS } from "../../../charts/colors"

const STATUS_FILL = {
    ORDER_PLACED: STATUS_COLORS.ORDER_PLACED,
    INTRANSIT: STATUS_COLORS.INTRANSIT,
    DELIVERED: STATUS_COLORS.DELIVERED,
    RTO: STATUS_COLORS.RTO,
    DELIVERY_FAILED: STATUS_COLORS.DELIVERY_FAILED,
    CANCELLED: STATUS_COLORS.CANCELLED,
    LOST: STATUS_COLORS.LOST,
}

const chartOptions = {
    layout: 'horizontal',
    xaxis: 'name',
    labelY: 'Shipments Count',
    stackId: 'status',
    showLabels: true,
    legendAlign: 'left',
    totalAccessor: (entry) => {
        if (!entry) return null
        const t = grpupedOrderStatus.reduce((sum, s) => sum + (entry[s] || 0), 0)
        return t
    },
    data: grpupedOrderStatus.map(status => ({
        dataKey: status,
        label: status.replace(/_/g, " "),
        chartType: 'bar',
        fill: STATUS_FILL[status] || '#9e9e9e',
    }))
}

export default function StatusWiseSplit({ data }) {
    const totalColumnsCount = data?.groupedByStatus?.length || 4

    return (
        <Card elevation={1}>
            <CardHeader title="Status Wise Shipments Trends" />
            <CardContent>
                <Grid container spacing={2}>
                    {data?.groupedByStatus?.map((row) => (
                        <Grid key={row.status} item xs={Number(numberPrecision(12 / totalColumnsCount))}>
                            <InfoBox header={row.status.replace(/_/g, " ")} value={formatNumber(row.count)} />
                        </Grid>
                    ))}
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <StackedBarChart data={data.lineChartData} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
